import { render, staticRenderFns } from "./PackagesAndComponents.vue?vue&type=template&id=dba72384&scoped=true"
import script from "./PackagesAndComponents.vue?vue&type=script&lang=js"
export * from "./PackagesAndComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba72384",
  null
  
)

export default component.exports